var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    y: 350.32,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 67.37
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M181.548,126.06l-13.252,39.736l-41.886,0.325c-4.017,0.031-5.682,5.157-2.451,7.543l33.696,24.883   l-12.635,39.937c-1.212,3.83,3.149,6.998,6.417,4.662l34.078-24.357l34.078,24.357c3.268,2.336,7.628-0.832,6.417-4.662   l-12.635-39.937l33.696-24.883c3.231-2.386,1.566-7.512-2.451-7.543l-41.886-0.325l-13.252-39.736   C188.208,122.249,182.819,122.249,181.548,126.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M86.074,52.733l-7.671,23L54.159,75.92c-2.325,0.018-3.289,2.985-1.419,4.366l19.504,14.402   l-7.313,23.116c-0.701,2.217,1.823,4.05,3.714,2.698l19.725-14.098l19.725,14.098c1.891,1.352,4.415-0.482,3.714-2.698   l-7.313-23.116L124,80.286c1.87-1.381,0.906-4.348-1.419-4.366l-24.244-0.188l-7.671-23C89.929,50.527,86.809,50.527,86.074,52.733   z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCw);
export default __webpack_public_path__ + "static/media/CW.986c9710c12d61d8c494d5fc77bbc78b.svg";
export { ForwardRef as ReactComponent };